import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getNamedColor as t } from "../../colorUtils.js";
import { px2pt as s } from "../../core/screenUtils.js";
import { c as r } from "../../chunks/mat4f32.js";
import { sepia as o, saturate as e, invert as i, grayscale as a, contrast as h, brightness as n, rotateHue as u } from "./colorMatrixFunctions.js";

function c(t) {
  return "colorMatrix" in t;
}

var l = /*#__PURE__*/function () {
  function l(t, s, r) {
    _classCallCheck(this, l);

    this.strength = t, this.radius = s, this.threshold = r, this.type = "bloom";
  }

  _createClass(l, [{
    key: "interpolate",
    value: function interpolate(t, s, r) {
      this.strength = y(t.strength, s.strength, r), this.radius = y(t.radius, s.radius, r), this.threshold = y(t.threshold, s.threshold, r);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new l(this.strength, this.radius, this.threshold);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "bloom",
        radius: x(this.radius),
        strength: this.strength,
        threshold: this.threshold
      };
    }
  }]);

  return l;
}();

var p = /*#__PURE__*/function () {
  function p(t) {
    _classCallCheck(this, p);

    this.radius = t, this.type = "blur";
  }

  _createClass(p, [{
    key: "interpolate",
    value: function interpolate(t, s, r) {
      this.radius = Math.round(y(t.radius, s.radius, r));
    }
  }, {
    key: "clone",
    value: function clone() {
      return new p(this.radius);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "blur",
        radius: x(this.radius)
      };
    }
  }]);

  return p;
}();

var d = /*#__PURE__*/function () {
  function d(t, s) {
    _classCallCheck(this, d);

    this.type = t, this.amount = s, "invert" !== this.type && "grayscale" !== this.type && "sepia" !== this.type || (this.amount = Math.min(this.amount, 1));
  }

  _createClass(d, [{
    key: "colorMatrix",
    get: function get() {
      return this._colorMatrix || this._updateMatrix(), this._colorMatrix;
    }
  }, {
    key: "interpolate",
    value: function interpolate(t, s, r) {
      this.amount = y(t.amount, s.amount, r), this._updateMatrix();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new d(this.type, this.amount);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: this.type,
        amount: this.amount
      };
    }
  }, {
    key: "_updateMatrix",
    value: function _updateMatrix() {
      var t = this._colorMatrix || r();

      switch (this.type) {
        case "brightness":
          this._colorMatrix = n(t, this.amount);
          break;

        case "contrast":
          this._colorMatrix = h(t, this.amount);
          break;

        case "grayscale":
          this._colorMatrix = a(t, this.amount);
          break;

        case "invert":
          this._colorMatrix = i(t, this.amount);
          break;

        case "saturate":
          this._colorMatrix = e(t, this.amount);
          break;

        case "sepia":
          this._colorMatrix = o(t, this.amount);
      }
    }
  }]);

  return d;
}();

var m = /*#__PURE__*/function () {
  function m(t, s, r, o) {
    _classCallCheck(this, m);

    this.offsetX = t, this.offsetY = s, this.blurRadius = r, this.color = o, this.type = "drop-shadow";
  }

  _createClass(m, [{
    key: "interpolate",
    value: function interpolate(t, s, r) {
      this.offsetX = y(t.offsetX, s.offsetX, r), this.offsetY = y(t.offsetY, s.offsetY, r), this.blurRadius = y(t.blurRadius, s.blurRadius, r), this.color[0] = Math.round(y(t.color[0], s.color[0], r)), this.color[1] = Math.round(y(t.color[1], s.color[1], r)), this.color[2] = Math.round(y(t.color[2], s.color[2], r)), this.color[3] = y(t.color[3], s.color[3], r);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new m(this.offsetX, this.offsetY, this.blurRadius, _toConsumableArray(this.color));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _toConsumableArray(this.color);

      return t[3] *= 255, {
        type: "drop-shadow",
        xoffset: x(this.offsetX),
        yoffset: x(this.offsetY),
        blurRadius: x(this.blurRadius),
        color: t
      };
    }
  }]);

  return m;
}();

var f = /*#__PURE__*/function () {
  function f(t) {
    _classCallCheck(this, f);

    this.angle = t, this.type = "hue-rotate";
  }

  _createClass(f, [{
    key: "colorMatrix",
    get: function get() {
      return this._colorMatrix || this._updateMatrix(), this._colorMatrix;
    }
  }, {
    key: "interpolate",
    value: function interpolate(t, s, r) {
      this.angle = y(t.angle, s.angle, r), this._updateMatrix();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new f(this.angle);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "hue-rotate",
        angle: this.angle
      };
    }
  }, {
    key: "_updateMatrix",
    value: function _updateMatrix() {
      var t = this._colorMatrix || r();
      this._colorMatrix = u(t, this.angle);
    }
  }]);

  return f;
}();

var M = /*#__PURE__*/function () {
  function M(t) {
    _classCallCheck(this, M);

    this.amount = t, this.type = "opacity", this.amount = Math.min(this.amount, 1);
  }

  _createClass(M, [{
    key: "interpolate",
    value: function interpolate(t, s, r) {
      this.amount = y(t.amount, s.amount, r);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new M(this.amount);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "opacity",
        amount: this.amount
      };
    }
  }]);

  return M;
}();

function y(t, s, r) {
  return t + (s - t) * r;
}

function x(t) {
  return Math.round(1e3 * s(t)) / 1e3;
}

function g(s) {
  switch (s.type) {
    case "grayscale":
    case "sepia":
    case "invert":
      return new d(s.type, 0);

    case "saturate":
    case "brightness":
    case "contrast":
      return new d(s.type, 1);

    case "opacity":
      return new M(1);

    case "hue-rotate":
      return new f(0);

    case "blur":
      return new p(0);

    case "drop-shadow":
      return new m(0, 0, 0, _toConsumableArray(t("transparent")));

    case "bloom":
      return new l(0, 0, 1);
  }
}

export { l as BloomEffect, p as BlurEffect, d as ColorMatrixEffect, m as DropShadowEffect, f as HueRotateEffect, M as OpacityEffect, g as createEffectWithInitialValues, c as isColorMatrixEffect };